import { ScrollReveal } from '@/components/ui/ScrollReveal';
import { Button } from '@/components/ui/button';
import { LocalizedLink } from '@/components/LocalizedLink';
import { useTranslation } from 'react-i18next';

const dayKeys = ['saturday', 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday'] as const;

export const Reservation = () => {
  const { t } = useTranslation(['home', 'common']);
  const hours = t('home:reservation.hours', { returnObjects: true }) as Record<string, string>;

  return (
    <section id="prenotazione" className="bg-background py-32 px-6" aria-labelledby="prenotazione-heading">
      <div className="mx-auto max-w-4xl text-center">
        <ScrollReveal>
          <span className="mb-4 inline-block text-sm font-light uppercase tracking-[0.3em] text-primary">
            {t('home:reservation.label')}
          </span>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <h2 id="prenotazione-heading" className="mb-8 text-4xl font-semibold text-foreground md:text-5xl lg:text-6xl">
            {t('home:reservation.title')}
            <br />
            <span className="text-primary">{t('home:reservation.brand')}</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <p className="mb-12 text-lg font-light text-muted-foreground">{t('home:reservation.text')}</p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-center">
            <Button variant="hero" size="xl" asChild>
              <LocalizedLink href="/prenota" aria-label={t('common:aria.bookTable')}>
                {t('common:cta.bookNow')}
              </LocalizedLink>
            </Button>
            <Button variant="ghost" size="lg" asChild>
              <a href="tel:+393472916493" className="underline-hover" aria-label={t('common:aria.callPhone')}>
                347 291 6493
              </a>
            </Button>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={400}>
          <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {dayKeys.map((day) => (
              <div key={day}>
                <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider text-primary">
                  {t(`common:days.${day}`)}
                </h3>
                <p className={hours[day] === 'Chiuso' || hours[day] === 'Closed' ? 'text-primary' : 'text-muted-foreground'}>
                  {hours[day] === 'Chiuso' || hours[day] === 'Closed' ? t('common:closed') : hours[day]}
                </p>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
